import {
    Form,
    Input,
    Button,
    Typography,
    Card,
    message, Row, Col,
} from 'antd';
import {useTranslation} from 'react-i18next';
import React from 'react';
import {BackgroundObject, BackgroundObject2, Logo} from "../icons";
import {useResizeEffect} from "../resize-effect";
import PublicPageLayout from "../public-page-layout";
import Icon from "@ant-design/icons";
import {Link} from "react-router-dom";

const {Title, Text} = Typography;

const CollectEmails = () => {
    const {t} = useTranslation();
    const isMobile = useResizeEffect();

    const onFinish = (values) => {
        console.log('Received values:', values);
        message.success(t('Thank you for subscribing!'));
        // Here you would send the data to your API
    };

    return (
        <PublicPageLayout>
            <Card className="public-page-content">
                <Row type="flex" justify="center">
                    <Link to="/">
                        <Icon className="login-form-logo" component={Logo}/>
                    </Link>
                </Row>

                <Row type="flex" justify="center">
                    <Col span={24} md={20} xl={16}>
                        <Title level={3} style={{marginBottom: 16, textAlign: 'center'}}>
                            {t('newsletters.title')}
                        </Title>

                        <Text type="secondary" style={{display: 'block', textAlign: 'center', marginBottom: 24}}>
                            {t('newsletter.content')}
                        </Text>

                        <Form layout="vertical" onFinish={onFinish}>
                            <Form.Item
                                name="name"
                                label={t('settings.personal.first-name')}
                            >
                                <Input placeholder={t('settings.personal.first-name')} size="large"/>
                            </Form.Item>

                            <Form.Item
                                name="email"
                                label={t('login.form.email')}
                                rules={[{
                                    type: 'email', message: t('login.form.error.email-invalid'),
                                }, {
                                    required: true, message: t('login.form.error.email-required')
                                }]}
                            >
                                <Input placeholder={t('login.form.email')} size="large"/>
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    size="large"
                                    block
                                    style={{marginTop: 8}}
                                >
                                    {t('newsletter.btn')}
                                </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </PublicPageLayout>
    );
};

export default CollectEmails;
